/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { IOTestStepLogBase } from './IOTestStepLogBase';
const IOTestStepLogParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['stdout', /* #__PURE__ */ codecOptional(codecString)],
    ['stderr', /* #__PURE__ */ codecOptional(codecString)],
    ['exitCode', /* #__PURE__ */ codecOptional(codecNumber), 'exit_code'],
    [
        'timeSpend',
        /* #__PURE__ */ codecOptional(parsers.duration),
        'time_spend',
    ],
    [
        'startedAt',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.maybeNull(parsers.moment)),
        'started_at',
    ],
    [
        'achievedPoints',
        /* #__PURE__ */ codecOptional(codecNumber),
        'achieved_points',
    ],
])), IOTestStepLogBase);
export class IOTestStepLog extends IOTestStepLogBase {
    static decode(input) {
        return IOTestStepLogParser.decode(input).map(res => new IOTestStepLog(res));
    }
    static unsafeDecode(input) {
        return IOTestStepLog.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IOTestStepLogParser.encode(data);
    }
    static schema() {
        return IOTestStepLogParser.schema();
    }
}
